export default "__VITE_ASSET__DfVfeP94__"